// extracted by mini-css-extract-plugin
export var bodyRow = "_cm-d";
export var cardColumns = "_cm-e";
export var ellipsesOverflow = "_cm-2";
export var flatBottomCorners = "_cm-3";
export var flatTopCorners = "_cm-4";
export var headerActionsDropdown = "_cm-f";
export var headerBottomRow = "_cm-c";
export var headerTopRow = "_cm-b";
export var orderDetailsWrapper = "_cm-0";
export var orderInfoContainer = "_cm-1";
export var productDetails = "_cm-9";
export var productImage = "_cm-5";
export var responsiveTable = "_cm-8";
export var shipmentContainer = "_cm-a";
export var tableBottomLeft = "_cm-6";
export var tableBottomRight = "_cm-7";
export var trackingLink = "_cm-g";